/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */

import { NgModule } from '@angular/core';
import { StoreComponent } from './components/store.component';
import { StoreItemsComponent } from './components/storeitems.component';
import { StoreFilterComponent } from './components/storefilter.component';
import { StoreItemDetailComponent } from './components/storeitemdetail.component';
import { StoreRoutingModule } from './store-routing.module';
import { StoreItemsService } from './services/storeitems.service';
import { ReactiveFormsModule } from '@angular/forms';
import { StoreItemDetailService } from './services/storeitemdetail.service';
import { SpinnerModule } from '../../../shared/spinner/spinner.module';
import { TinymceModule } from '../../../shared/tinymce/tinymce.module';
import { CustomfieldsModule } from '../../feature/shared/module/customfields.module';
import { AdditionalinfoModule } from '../../feature/shared/module/additionalinfo.module';
import { ContactinfoModule } from '../../feature/shared/module/contactinfo.module';
import { FileUploadModule } from '../../../shared/fileupload/fileupload.module';
import { InfiniteScrollModule } from '../shared/module/infinite-scroll.module';
import { SharedModule } from '../../../shared/shared.module';
import { RequestDetailService } from '../requests/services/request-detail.service';
import { RequestslistService } from '../requests/services/requestslist.service';
import { ZsdFormIOModule } from '../newrequest/quickcall/zsdformio/zsdformio.module';

 @NgModule({
  imports: [
    SharedModule,
    StoreRoutingModule,
    ReactiveFormsModule,
    SpinnerModule,
    TinymceModule,
    CustomfieldsModule,
    AdditionalinfoModule,
    ContactinfoModule,
    FileUploadModule,
    InfiniteScrollModule,
    ZsdFormIOModule
  ],
  declarations: [ StoreComponent, StoreItemsComponent, StoreFilterComponent, StoreItemDetailComponent ],
  providers: [ StoreItemsService, StoreItemDetailService, RequestDetailService, RequestslistService ],
  exports: [ StoreComponent ]
})
export class StoreModule { }
